<script setup>
import { computed } from "vue";

const props = defineProps({
  userprices: Object,
  subheader: String,
  city: Object,
  secondbannerimgmobile: String,
  reviewcoutnt: Number,
  rating: Number,
  metaimage: String,
  keyword: String,
});

// ⚠ ВАРИАНТ «А» ИЗ МАКЕТОВ (21.09.2026): прайс-лист. Цены — столбцом справа,
// одной строкой, «1 500 ₽»; услуги от дешёвой к дорогой. Раньше «15000 рублей»
// ломалось на две строки, а чёрный кружок «?» с «диапазоном цен по региону»
// был тяжелее самой цены и ничего не добавлял.
const items = computed(() =>
  [...(props.userprices ?? [])].sort((a, b) => Number(a.price) - Number(b.price))
);
const rub = (n) => Number(n).toLocaleString("ru-RU") + " ₽";
</script>

<template>
  <section
    id="prices"
    v-if="userprices[0]"
    class="bg-white py-8 md:py-12 antialiased"
  >
    <div class="mx-auto max-w-7xl px-4 md:px-8">
      <div class="max-w-3xl">
        <h2 class="text-2xl font-bold tracking-tight text-gray-900">Цены</h2>

        <div class="mt-4 divide-y divide-gray-200">
          <div
            v-for="item in items"
            :key="item.name + item.price"
            itemprop="offers"
            class="py-3 grid grid-cols-[1fr_auto] gap-x-4 gap-y-1"
            itemscope
            itemtype="http://schema.org/Offer"
          >
            <div itemprop="name" class="font-bold text-gray-900 leading-snug">
              {{ item.name }}
            </div>

            <div class="font-extrabold text-gray-900 whitespace-nowrap text-right tabular-nums">
              <meta itemprop="price" :content="item.price.toString()" />
              <meta itemprop="priceCurrency" content="RUB" />
              <template v-if="item.price != 0">{{ rub(item.price) }}</template>
              <template v-else>бесплатно</template>
            </div>

            <div v-if="item.value" class="col-span-2 text-sm text-gray-500 leading-relaxed" itemprop="description">
              {{ item.value }}
            </div>

            <!-- Служебные свойства Offer для Google Merchant: на экране не видны -->
            <div class="hidden">
              <meta itemprop="priceValidUntil" content="2027-01-01" />
              <meta itemprop="availability" content="https://schema.org/InStock" />

              <div itemprop="shippingDetails" itemtype="https://schema.org/OfferShippingDetails" itemscope>
                <div itemprop="shippingRate" itemtype="https://schema.org/MonetaryAmount" itemscope>
                  <meta itemprop="value" content="0" />
                  <meta itemprop="currency" content="RUB" />
                </div>
                <div itemprop="shippingDestination" itemtype="https://schema.org/DefinedRegion" itemscope>
                  <meta itemprop="addressCountry" content="RU" />
                </div>
                <div itemprop="deliveryTime" itemtype="https://schema.org/ShippingDeliveryTime" itemscope>
                  <div itemprop="handlingTime" itemtype="https://schema.org/QuantitativeValue" itemscope>
                    <meta itemprop="minValue" content="0" />
                    <meta itemprop="maxValue" content="1" />
                    <meta itemprop="unitCode" content="DAY" />
                  </div>
                  <div itemprop="transitTime" itemtype="https://schema.org/QuantitativeValue" itemscope>
                    <meta itemprop="minValue" content="0" />
                    <meta itemprop="maxValue" content="1" />
                    <meta itemprop="unitCode" content="DAY" />
                  </div>
                </div>
              </div>

              <div itemprop="hasMerchantReturnPolicy" itemtype="https://schema.org/MerchantReturnPolicy" itemscope>
                <meta itemprop="applicableCountry" content="RU" />
                <meta itemprop="returnMethod" content="https://schema.org/ReturnByMail" />
                <meta itemprop="returnFees" content="https://schema.org/FreeReturn" />
                <meta itemprop="returnPolicyCategory" content="https://schema.org/MerchantReturnFiniteReturnWindow" />
                <meta itemprop="merchantReturnDays" content="3" />
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>
